export default {
	theme: 'snow',
	boundary: document.body,
	placeholder: 'Insert text here ...',
	readOnly: false
}


// WEBPACK FOOTER //
// ./src/modules/webEditor/options.js